<template>
<el-dialog
      title="选择组织机构"
      :visible.sync="propsData.visible"
      :close-on-click-modal="false"
      @close="closeDialog()"
      class="topDialog chooseOrganizationDialog"
      :close-on-press-escape="false">
      <div  style="height:380px;overflow: auto;">
        <div>
          <el-tree
            ref="treeModal"
            :key="tree_key"
            :data="treeData"
            node-key="id"
            :props="elTreeProps"
            :expand-on-click-node="false"
            default-expand-all
            :current-node-key="currentNode"
            :highlight-current="true"
            @node-click="nodeClick">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span>
                    <span style="color:red" v-if="data.removed">（已停用）</span>
                  </span>
              </span>
            </el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="confirm()">确定</el-button>
        <el-button size="small" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
</template>

<script>
export default {
    name: "departmentName",
    components: {},
    props: ["propsData"],
    data(){
        return{
            treeData: [],
            tree_key: 0,
            currentNode: "",
            elTreeProps: {
                children: "children",
                label: "name"
            },
        }
    },
    methods: {

        show(rootOrganizationId){
            this.propsData.visible = true;
            this.getOrganizationTree(rootOrganizationId);
        },

        getOrganizationTree(rootOrganizationId) {

            if (rootOrganizationId == undefined || rootOrganizationId==null) 
            {
                rootOrganizationId =""; 
            }

            this.$organizationApi.getOrganizationTree(rootOrganizationId,this.propsData.includeRemoved)
            .then(res => 
            {
                this.treeData = [];
                if (res.data.successful) 
                {
                    this.treeData = res.data.data;
                    this.currentNode = this.treeData[0].id;
                } 
                else 
                {
                    this.$alert("获取组织机构失败！", "提示");
                }
            });
        },

        nodeClick(data) {
           // this.$emit("chooseOrganizationCallback", data);
        },

        confirm(){
            this.propsData.visible = false;
            this.$emit("chooseOrganizationCallback", this.$refs.treeModal.getCurrentNode());
        },

        closeDialog() {
            this.propsData.visible = false;
        }

    }

}
</script>

<style rel="stylesheet/scss" lang="scss">

.chooseOrganizationDialog .el-dialog{
    top: 2vh !important;
    bottom: 2vh !important;
    left: 10% !important;
    right: 10% !important;
    width: 500px !important;
    height: 500px !important;
}

</style>


// WEBPACK FOOTER //
// src/views/common/chooseOrganization.vue